import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import ProcessOrderOptimizer from './ProcessOrderOptimizer';

function App() {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  if (!(domain && clientId && audience)) {
    return (
      <div>
        <h1>Invalid authorization configuration</h1>
        <p>Please check your .env file configuration.</p>
      </div>
    );
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: window.location.origin,
      }}
    >
      <div className="App">
        <ProcessOrderOptimizer />
      </div>
    </Auth0Provider>
  );
}

export default App;
